// Created
export const CREATED = 'CREATED';
export const UPDATE_INFO = 'UPDATE_INFO';

// Geocoded
export const GEOCODE_FAILED = 'GEOCODE_FAILED';
export const GEOCODE_FAILED_PICKUP = 'GEOCODE_FAILED_PICKUP';
export const GEOCODE_FAILED_DROPOFF = 'GEOCODE_FAILED_DROPOFF';
export const GEOCODED = 'GEOCODED';
export const UNSERVICEABLE = 'UNSERVICEABLE';

// Assigned
export const ASSIGNED = 'ASSIGNED';
export const PENDING = 'PENDING';

// Pickup
export const PICKUP_EN_ROUTE = 'PICKUP_EN_ROUTE';
export const PICKUP_DELAY = 'PICKUP_DELAY';
export const CANCELLED_BEFORE_PICKUP = 'CANCELLED_BEFORE_PICKUP';
export const PICKUP_READY = 'PICKUP_READY';
export const PICKUP_SCHEDULED = 'PICKUP_SCHEDULED';
export const PICKUP_FAILED = 'PICKUP_FAILED';
export const PICKUP_SUCCEEDED = 'PICKUP_SUCCEEDED';

// Dropoff
export const DROPOFF_EN_ROUTE = 'DROPOFF_EN_ROUTE';
export const DROPOFF_DELAY = 'DROPOFF_DELAY';
export const CANCELLED_AFTER_PICKUP = 'CANCELLED_AFTER_PICKUP';
export const DROPOFF_READY = 'DROPOFF_READY';
export const DROPOFF_FAILED = 'DROPOFF_FAILED';
export const DROPOFF_SUCCEEDED = 'DROPOFF_SUCCEEDED';
export const DROPOFF_ATTEMPTED = 'DROPOFF_ATTEMPTED';
export const DROPOFF_REATTEMPTING = 'DROPOFF_REATTEMPTING';
export const UNDELIVERABLE = 'UNDELIVERABLE';
export const RESCHEDULED = 'RESCHEDULED';

// Return
export const RETURN_EN_ROUTE = 'RETURN_EN_ROUTE';
export const RETURN_DELAY = 'RETURN_DELAY';
export const RETURN_READY = 'RETURN_READY';
export const RETURN_FAILED = 'RETURN_FAILED';
export const RETURN_MISSING = 'RETURN_MISSING';
export const RETURN_DAMAGED = 'RETURN_DAMAGED';
export const RETURN_SUCCEEDED = 'RETURN_SUCCEEDED';
export const RETURNED_TO_CLIENT_PENDING = 'RETURNED_TO_CLIENT_PENDING';
export const RETURNED_TO_CLIENT_SUCCEEDED = 'RETURNED_TO_CLIENT_SUCCEEDED';

// Inbound
export const RECEIVED_OK = 'RECEIVED_OK';
export const RECEIVED_DAMAGED = 'RECEIVED_DAMAGED';
export const MISSING = 'MISSING';
export const DISPOSABLE = 'DISPOSABLE';

// Outbound
export const NOT_FOUND = 'NOT_FOUND';
export const LEAKING = 'LEAKING';
export const DAMAGED = 'DAMAGED';
export const DRIVER_ASSIGNED = 'DRIVER_ASSIGNED';
export const DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED';

// COMMUNICATION
export const INFORM_RECIPIENT_SHIPMENT_CONFIRMED = 'INFORM_RECIPIENT_SHIPMENT_CONFIRMED';
export const INFORM_RECIPIENT_PICKUP_SUCCEEDED = 'INFORM_RECIPIENT_PICKUP_SUCCEEDED';
export const INFORM_RECIPIENT_PICKUP_SUCCEEDED_REASON = 'INFORM_RECIPIENT_PICKUP_SUCCEEDED_REASON';
export const INFORM_RECIPIENT_PICKUP_FAILED = 'INFORM_RECIPIENT_PICKUP_FAILED';
export const INFORM_RECIPIENT_COMING_SOON = 'INFORM_RECIPIENT_COMING_SOON';
export const INFORM_RECIPIENT_NEXT_IN_LINE = 'INFORM_RECIPIENT_NEXT_IN_LINE';
export const INFORM_RECIPIENT_DROPOFF_SUCCEEDED = 'INFORM_RECIPIENT_DROPOFF_SUCCEEDED';
export const INFORM_RECIPIENT_DROPOFF_SUCCEEDED_REASON = 'INFORM_RECIPIENT_DROPOFF_SUCCEEDED_REASON';
export const INFORM_RECIPIENT_DROPOFF_FAILED = 'INFORM_RECIPIENT_DROPOFF_FAILED';
